// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R0wv","top":"styles_top__3Wzm5","left":"styles_left__2GzKT","description":"styles_description__2BWm2"};